import * as React from 'react';
import { Link } from 'react-router';
import styled, { withTheme } from 'styled-components';
import { rem } from 'polished';
import { FlexRowCenterVertical, TextP } from '../../..';
import { IconType, SvgIcon } from '../General/SvgIcon';
import { FlexColCenter } from '../../Defaults/Flexbox/Flexbox';
import { WebP } from '../../Defaults/WebP';

interface Props {
  name: string;
  theme: any;
  url: string;
  img: string;
  lastParent: any;
  isInSearch?: boolean;
}

function CategoryCard({
  name,
  theme,
  url,
  img,
  lastParent,
  isInSearch,
}: Props) {
  return (
    <Wrapper isInSearch={isInSearch}>
      <ImageWrapper to={url} isInSearch={isInSearch}>
        <Image
          image={img}
          alt={`Obrázok kategórie ${name}`}
          width={180}
          height={180}
        />
      </ImageWrapper>
      <CategoryNameLink to={url} isInSearch={isInSearch}>
        {lastParent ? `...  / ${lastParent.category_name}  /  ` : ''}
        {name}
      </CategoryNameLink>
    </Wrapper>
  );
}

const Wrapper = styled(FlexColCenter)<{ isInSearch?: boolean }>`
  /* margin-right: ${rem(24)};
  margin-bottom: ${rem(16)}; */
  flex-direction: ${props => (props.isInSearch ? 'row' : 'column')};
  gap: ${props => (props.isInSearch ? rem(8) : 0)};
  width: 100%;

  @media only screen and (max-width: 720px) {
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    gap: ${rem(8)};
  }
`;

const ImageWrapper = styled(Link)<{ isInSearch?: boolean }>`
  display: flex;
  justify-content: center;
  align-items: center;
  width: ${props => (props.isInSearch ? rem(64) : rem(182))};
  height: ${props => (props.isInSearch ? rem(64) : rem(182))};
  margin-bottom: ${props => (props.isInSearch ? 0 : rem(16))};
  padding: ${rem(8)};
  border: ${({ theme }) => theme.borders.primary};
  border-radius: ${rem(4)};
  box-shadow: ${({ theme }) => theme.boxShadow.default};
  transition: transform 0.25s ease 0s;

  &:hover {
    transform: scale(1.1);
  }

  @media only screen and (max-width: 720px) {
    width: ${rem(40)};
    height: ${rem(40)};
    padding: ${rem(1)};
    margin-bottom: 0;
    flex-shrink: 0;
  }
`;

const Image = styled(WebP)`
  width: 100%;
  height: 100%;
`;

const CategoryNameLink = styled(Link)<{ isInSearch?: boolean }>`
  font-size: ${rem(20)};
  line-height: ${rem(22)};
  color: ${({ theme }) => theme.colors.textPrimary};
  max-width: ${props => (props.isInSearch ? 'unset' : rem(182))};
  text-align: ${props => (props.isInSearch ? 'left' : 'center')};
  width: ${props => (props.isInSearch ? '100%' : 'auto')};
  height: ${rem(64)};
  font-size: ${rem(14)};
  text-decoration: none;
  display: flex;
  align-items: ${props => (props.isInSearch ? 'center' : 'unset')};

  &:hover {
    text-decoration: underline;
  }

  @media only screen and (max-width: 720px) {
    height: auto;
    text-align: left;
  }
`;

const WithTheme: any = withTheme(CategoryCard);
export { WithTheme as CategoryCard };
